module.exports = __webpack_public_path__ + "img/usecase1.0f00e2b.svg";